import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const CancelTransferForm = () => {
  const { chatData, refreshChatData, validateEcode } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelTransfer = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://kracet.shop/mastapi/canceltransfer.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatData?.chat_id,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Transfer cancelled successfully!");
        refreshChatData();
        validateEcode();
      } else {
        alert("Failed to cancel transfer: " + result.message);
      }
    } catch (error) {
      console.error("Error cancelling transfer:", error);
      alert("An error occurred while cancelling the transfer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleCancelTransfer}
      className="text-center mt-4 pb-4 border-b-2 border-dotted"
    >
      <p className="text-xl pb-1 text-yellow-800 font-semibold">
        Transfer in Progress !!!
      </p>
      <p className="text-lg font-medium text-gray-700">{chatData?.email}</p>

      <div>
        <button
          type="submit"
          className="bg-yellow-800 px-4 py-2 mt-2 rounded-lg text-white flex items-center justify-center mx-auto"
          disabled={isLoading}
        >
          {isLoading ? (
            <svg
              className="animate-spin h-5 w-5 mr-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8z"
              ></path>
            </svg>
          ) : null}
          {isLoading ? "Cancelling..." : "Cancel Current Transfer"}
        </button>
      </div>
    </form>
  );
};

export default CancelTransferForm;
